import ReactSelect from "react-select";
import { usePromptLabels } from "queries/promptLabels";

// Only ever rendered inside the "Your AI" toggle's conditional block, which
// itself only mounts once the Create Account modal is open (MUI's Modal
// doesn't mount its children until `open` is true) - so this query only
// fires when someone actually needs the tag list, not on every page load.
function TagsSelect({ agencyId, selectedIds, onChange }) {
  const { data: tagsoption = [] } = usePromptLabels({ agencyId, type: "agency" });

  return (
    <ReactSelect
      name="tags"
      placeholder="Select AI Agent templates"
      className="form-input w-full"
      options={
        Array.isArray(tagsoption)
          ? tagsoption.map((item) => ({
            label: item.name,
            value: item._id,
          }))
          : []
      }
      value={
        Array.isArray(tagsoption)
          ? tagsoption
            .filter((item) => selectedIds.includes(item._id))
            .map((item) => ({ label: item.name, value: item._id }))
          : []
      }
      isMulti={true}
      onChange={onChange}
    />
  );
}

export default TagsSelect;
